import React, { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import cn from 'clsx'
import s from './Navbar.module.scss'
import NavbarRoot from './NavbarRoot'
import { Logo, Container, Button } from '@components/ui'
import { useUI } from '@components/ui/context'
import { Searchbar, UserNav } from '@components/common'
import LogoStroke from '@components/ui/Logo/LogoStroke'
import { useWindowSize } from 'usehooks-ts'
import { isMobileWidth } from '@utils/helpers'

interface LinkItem {
  href: string
  label: string
  action?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

interface NavbarProps {
  links?: LinkItem[]
}

const Navbar: FC<NavbarProps> = ({ links }) => {
  const { pageTheme, displayLoreThreeNavOverlay } = useUI()
  const { asPath } = useRouter()

  return (
    <NavbarRoot>
      <Container
        clean
        className={cn(s.container, {
          [s.darkMode]: pageTheme == 'LIGHT' && !displayLoreThreeNavOverlay,
        })}
      >
        <div className={s.nav}>
          <div className={s.links}>
            <Link href="/">
              <a className={s.logo} aria-label="Logo">
                <LogoStroke
                  className={s.logoImage}
                  color={
                    pageTheme == 'LIGHT' && !displayLoreThreeNavOverlay
                      ? 'LIGHT'
                      : 'DARK'
                  }
                />
              </a>
            </Link>
            <nav className={s.navMenu}>
              {links?.map((l, index: number) => (
                <React.Fragment key={`link-${index}`}>
                  {l.action ? (
                    <Button
                      variant={
                        pageTheme == 'LIGHT' && !displayLoreThreeNavOverlay
                          ? 'blackNaked'
                          : 'naked'
                      }
                      className={cn(s.actionButton, {
                        [s.buttonActive]: asPath.split('/')[1] == 'lorethree',
                      })}
                      onClick={(e) => l.action && l.action(e)}
                    >
                      {l.label}
                    </Button>
                  ) : (
                    <Link href={l.href} key={l.href} prefetch={false}>
                      <a
                        className={cn(s.link, { [s.active]: asPath == l.href })}
                      >
                        {l.label}
                      </a>
                    </Link>
                  )}
                </React.Fragment>
              ))}
            </nav>
          </div>

          <div className={s.accountContainer}>
            <UserNav />
          </div>
        </div>
      </Container>
    </NavbarRoot>
  )
}

export default Navbar
